<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html {
  background: linear-gradient(180deg, #2d2d44 0%, #1a1a2e 100%);
}
</style>
